import React, { useState } from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import InfoIcon from "@material-ui/icons/Info";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import eightAxios from "configs/axiosConfig";
import AudioPlayer from "components/AudioPlayer";
import Collapse from "@material-ui/core/Collapse";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useFormikContext } from "formik";
import HoverTooltip from "components/Tooltip/HoverTooltip";
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  labelSpan: {
    fontWeight: "500",
  },
  valueSpan: {
    width: "100%",
    textTransform: "uppercase",
  },
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const RenderOnlyField = (props) => {
  const { label, value, valueType,infobutton,supportedTypes, isMulti, ...rest } = props;
  const classes = useStyles();
  const [showAudio, setShowAudio] = useState(false);
  const formik = useFormikContext();
  let newValue = value;
  let supportedTypeMessage;
  if (supportedTypes) {
    const modifiedSupportedTypes = supportedTypes.map((type) => `${type}`);
    supportedTypeMessage = modifiedSupportedTypes.join(", ");
  }
  if (valueType === "audioLink") {
    return (
      <Grid container item lg={12} direction="column">
        <Grid item lg={12}>
          <span className={classes.labelSpan}>{label}</span>
        </Grid>
        <Grid item lg={12}>
          <span
            className={classes.nameSpan}
            style={{
              display: "flex",
            }}
            onClick={() => setShowAudio(!showAudio)}
          >
            Show Audio {showAudio ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </span>
          <Collapse in={showAudio} unmountOnExit>
            <AudioPlayer audioSrc={value} />
          </Collapse>
        </Grid>
      </Grid>
    );
  }

  if (value === null || value === undefined || value === "" || value === "Not Assigned") {
    if (!formik.values[rest.name]) {
      newValue = "N/A";
    } else {
      newValue = formik.values[rest.name];
    }
  }

  if (valueType === "link") {
    newValue = (
      <a
        style={{
          cursor: "pointer",
        }}
        onClick={() => {
          rest.authClick
            ? eightAxios
                .get(value)
                .then()
                .catch()
                .finally(window.open(value, "_blank"))
            : window.open(value, "_blank");
        }}
      >{`${rest.linkWrapper}-${rest.linkWrapperText}`}</a>
    );
  }

  if (valueType === "boolean") {
    newValue = value || formik.values[rest.name] ? rest.yesValue : rest.noValue;
  }

  if (value != null && valueType === "date_time") {
    if (rest.parseTimeOnly) {
      newValue = format(Date.parse(value), "h:mm:ss a");
    } else {
      newValue = format(Date.parse(value), "dd/MM/yyyy h:mm:ss a");
    }
  }

  if (value != null && valueType === "date_time_origin") {
    if (rest.parseTimeOnly) {
      // Parse and format only the time portion
      let tempTime = new Date(value);
      newValue = tempTime.toLocaleTimeString("en-GB", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
        timeZone: 'Asia/Singapore'
      });
    } else {
      // Parse and format both date and time
      let tempTime = new Date(value);
      newValue = tempTime.toLocaleString("en-GB", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: 'Asia/Singapore'
      });
    }
  }
  

  if (value != null && isMulti) {
    newValue = value.join(", ");
  }

  return (
    <Grid container item lg={12} direction="column">
      <Grid item lg={12}>
        <span className={classes.labelSpan}>{label}</span>
       {infobutton ? <HoverTooltip title={`${supportedTypeMessage}`}>
                  <IconButton style={{ padding: "0" }}>
                    <InfoIcon color="primary" />
                  </IconButton>
                </HoverTooltip>
: null}
      </Grid>
      <Grid
        item
        lg={12}
        style={{
          wordWrap: "break-word",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        
        <span className={classes.valueSpan}>{Array.isArray(newValue)? newValue.map(x => (<div key = {x}>{x}</div> )) : newValue} </span>
      </Grid>
    </Grid>
  );
};

RenderOnlyField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  valueType: PropTypes.string,
  isMulti: PropTypes.bool,
  infobutton: PropTypes.bool,
  supportedTypes: PropTypes.array,

};

export default RenderOnlyField;
